<template>
<div class="flex flex-row flex-wrap overflow-y-scroll h-96 prose">
 <table class="sizeChart" border="0" cellpadding="10" cellspacing="0" width="100%">
<thead>
  <tr>
    <td>Mens</td>
    <td>Small</td>
    <td>Medium</td>
    <td>Large</td>
    <td>X-Large</td>
    <td>XX-Large</td>
  </tr>
</thead>
<tbody>
<tr>
<td>Neck</td>
<td>14-14.5</td>
<td>15-15.5</td>
<td>16-16.5</td>
<td>17-17.5</td>
<td>18-18.5</td>
</tr>
<tr>
<td>Chest</td>
<td>35-37</td>
<td>38-40</td>
<td>41-43</td>
<td>44-46</td>
<td>47-49</td>  
</tr>
<tr>
<td>Sleeve</td>
<td>32-33</td>
<td>33-34</td>
<td>34-35</td>
<td>35-36</td>
<td>36-36.5</td>
</tr>
<tr>
<td>Waist</td>
<td>29-31</td>
<td>32-34</td>
<td>35-37</td>
<td>38-40</td>
<td>41-43</td>
</tr>
</tbody>
</table>
<p><strong>Neck:</strong> Measure around the middle of your neck (at the Adam’s apple), keeping the tape a bit loose.</p>
<p>
<strong>Chest:</strong> Measure under your arms around the fullest part of your chest.
</p>
<p>
<strong>Arm length:</strong> Bend your elbow 90 degrees and place your hand on your hip. Hold the tape at the center of the back of your neck. Measure across your shoulder to your elbow and down to your wrist. The total length is your sleeve length.</p>
<p>
<strong>Waist:</strong> Measure around your natural waistline, keeping the tape a bit loose.</p>
</div>
</template>

<script>
export default {
    name: "Sizing"
}
</script>
